<div
  [style.height.%]="100"
  [style.max-height.px]="height()"
  [style.max-width.px]="width()"
  [style.width.%]="100">
  <app-image-thumbnail size="full">
    <img
      [alt]="alt()"
      [fill]="true"
      [ngSrc]="previewUrl()"
      class="object-contain"
      loading="lazy" />
  </app-image-thumbnail>
</div>
